import { Link } from 'react-router-dom';
import { streams } from '@/mocks/mogu-data';

export default function HotStreams() {
  const hotStreams = streams.slice(0, 8);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              <i className="ri-fire-line text-primary-500 mr-2"></i>热门直播
            </h2>
            <p className="mt-2 text-sm text-foreground-600">实时热门直播，精彩不容错过</p>
          </div>
          <Link
            to="/category/game"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotStreams.map((stream) => (
            <Link
              key={stream.id}
              to={`/category/${stream.category}`}
              className="group rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-colors"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={stream.thumbnail}
                  alt={stream.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
                    <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-pulse"></span>
                    直播中
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 rounded-full bg-black/60 text-background-50 text-xs">
                    <i className="ri-eye-line mr-1"></i>
                    {stream.viewers > 10000
                      ? `${(stream.viewers / 10000).toFixed(1)}万`
                      : stream.viewers}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug">
                  {stream.title}
                </h3>
                <div className="flex items-center gap-2 mt-3">
                  <img
                    src={stream.anchorAvatar}
                    alt={stream.anchor}
                    className="w-6 h-6 rounded-full object-cover"
                    loading="lazy"
                  />
                  <span className="text-xs text-foreground-600">{stream.anchor}</span>
                </div>
                <div className="flex items-center gap-1.5 mt-2 flex-wrap">
                  {stream.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 rounded-md bg-background-200 text-foreground-600 text-xs"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex sm:hidden justify-center mt-8">
          <Link
            to="/category/game"
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部热门直播 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}